const FULLSCREEN_OVERLAY_ID = '#fullscreen-overlay'

class DomUtils {

  fullscreenOverlay = () => document.querySelector(FULLSCREEN_OVERLAY_ID)

  clearFullscreenOverlay() {
    this._removeAllChildNodes(this.fullscreenOverlay())
  }

  moveToFullscreenOverlay(el) {
    this.fullscreenOverlay().appendChild(el)
  }

  _removeAllChildNodes(parent) {
    while (parent.firstChild) parent.removeChild(parent.firstChild)
  }
}

export default new DomUtils()
